import AppRoutes from "./routes/app-routes";

// MUI Imports
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import CustomSnackbar from "./components/Snackbar/Snackbar";
import AuthDialog from "./components/auth-dialog/auth-dialog";

// Custom Components
import { CustomGridPagination } from "./components/pagination/pagination";

// Enable TailwindCSS overwrites in MUI Components with some additional theme overrides
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536,
    },
  },
  typography: {
    fontFamily: ['"Inter"', "sans-serif"].join(","),
  },
  palette: {
    white: {
      main: "#FFFFFF",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiPopover: {
      defaultProps: {
        container: document.body,
      },
    },
    MuiPopper: {
      defaultProps: {
        container: document.body,
      },
    },
    MuiDialog: {
      defaultProps: {
        container: document.body,
      },
    },
    MuiDataGrid: {
      defaultProps: {
        slots: {
          pagination: CustomGridPagination,
        },
      },
    },
  },
});

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppRoutes />
        <CustomSnackbar />
        <AuthDialog />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
